<template>
  <div id="recharge">
    <div class="inner">
      <el-row
        class="title"
        style="
          border-bottom: dashed 1px rgba(151, 151, 151, 0.5);
          padding-bottom: 8px;
        "
      >
        <el-col :span="20">
          <div class="grid-content bg-purple-dark box-title">
           {{card_name}}充值
          </div>
          <div></div>
        </el-col>
        <el-col :span="4" style="text-align: right">
          <div
            class="grid-content bg-purple-dark ft15"
            style="font-weight: 400; line-height: 40px; display: inline-block"
          >
            <span>
              <router-link
                style="
                  font-size: 13px;
                  font-family: MicrosoftYaHei;
                  color: #7a7a7a;
                "
                :to="{ name: 'Mypoints' }"
                >充值记录</router-link
              >
            </span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </el-col>
      </el-row>
      <div>
        <transition name="fadein">
          <div v-if="step === 1">
            <div class="box">
              <div>
                <div class="card">
                  <p class="ts1"><span v-if="$store.state.webInfo.card_status==1">{{card_name}}</span> </p>
                  <div class="tbxq">
                    <p>欢迎使用</p>
                    <h1>{{card_name}}充值</h1>
                  </div>
                </div>
              </div>
              <div>
                <div class="box-form">
                  <div class="inputbox" style="margin: 0px 0 15px 0">
                    <input
                      type="text"
                      v-model="cardNum"
                      class="ft13"
                      placeholder="请输入充值卡编号（字母为大写）"
                    />
                  </div>
                  <div class="yzm-box clearfloat">
                    <div
                      class="inputbox"
                      style="display: inline-block; float: left"
                    >
                      <input
                        type="text"
                        v-model="code"
                        class="ft13"
                        placeholder="请输入验证码"
                      />
                    </div>
                    <div class="yzm" @click="refreshCode">
                      <s-identify
                        :identifyCode="identifyCode"
                        :contentWidth="88"
                        :contentHeight="44"
                        style="margin-top: 4px"
                      ></s-identify>
                    </div>
                  </div>
                  <p class="tit">{{ error }}</p>
                  <button
                    class="inputbox theme-bg"
                    style="
                      color: #fff;
                      display: inline-block;
                      line-height: 52px;
                      height: 52px;
                      text-align: center;
                      margin-top: 20px;
                    "
                    @click="next()"
                  >
                    立即充值
                  </button>
                </div>
              </div>
            </div>
            <div class="box-tit">
              <p>温馨提示：</p>
            <p>1.我司发行的{{card_name}}为12/16位数字+字母组合，均为{{ $store.state.name }}卡。</p>
              <p>2.{{card_name}}的密码只能输入大写字母。</p>
              <p>3.{{card_name}}充值后将立即到账。</p>
            </div>
          </div>
        </transition>
        <transition name="fadein">
          <div v-if="step == 2">
            <div class="box" style="justify-content: space-around">
              <div class="card">
                <p class="ts1">{{card_name}}</p>
                <div class="tbxq">
                  <p>{{ $store.state.name }}余额</p>
                  <h1>{{ point.detail.point }}{{ $store.state.name }}</h1>
                  <p
                    style="
                      margin-top: 46px;
                      font-size: 13px;
                      font-family: PingFangSC-Semibold, PingFang SC;
                      font-weight: 600;
                      color: #ffffff;
                      line-height: 19px;
                    "
                  >
                    卡号：{{ cardNum }}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div
                class=""
                style="
                  padding-top: 40px;
                  text-align: center;
                  margin-bottom: 14px;
                "
              >
                <img src="/static/img/sucess.png" style="width: 44px" />
              </div>

              <p
                style="
                  margin-bottom: 18px;
                  height: 40px;
                  font-size: 24px;
                  font-family: MicrosoftYaHei;
                  color: #262626;
                  line-height: 40px;
                  text-align: center;
                "
              >
                <!-- <i class="el-icon-circle-check theme-col"></i> -->
                &nbsp;恭喜您，{{card_name}}充值成功！
              </p>
              <div class="buysuccess-text">
                <!-- <p style="">如意卡号：{{resultAccount}}</p> -->
                <p>充值面额：{{ getnum }}{{ $store.state.name }}</p>
                <!-- <p>充值时间：{{resultTime}}</p> -->
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <Nvc 
      ref="nverify" 
      :verify="verifyMethods"
    ></Nvc>
  </div>
</template>
<script>
import SIdentify from "@/common/identify";
import Nvc from "@/common/nvc";
export default {
  data() {
    return {
      step: 1,
      account: "", //转增账号
      integral: "", //转增积分
      password: "",
      identifyCodes: "1234567890",
      identifyCode: "",
      loginCode: "",
      resultTime: "",
      resultAccount: "",
      resultPoint: "",
      cardNum: "",
      code: "",
      getnum: "",
      error: "",
      point: {},
      nvctype: "nvc_login_h5",
    };
  },
  components: {
    SIdentify,
    Nvc,
  },
  watch: {
    integral(val) {
      this.integral = this.integral.replace(/[^\d]+|(^0)+/g, "");
    },

  },
  computed:{
    card_name(){
      return this.$store.state.webInfo.card_name;
    }
  },
  methods: {
    times: function (timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m;
      if (date.getMinutes() < 10) {
        m = "0" + date.getMinutes() + ":";
      } else {
        m = date.getMinutes() + ":";
      }
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    },
    //生成验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //生成验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    //生成验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    next: function () {
      // var reg = /^[0-9A-Z]{16}$/;
      console.log(this.cardNum);
      if (this.cardNum == '') {
        //  this.$message('请输入充值卡编号（字母为大写）!');
        this.error = "请输入充值卡编号（字母为大写）!";
      } else if (this.code == "") {
        // this.$message('验证码不能为空！');
        this.error = "验证码不能为空！";
        // this.$dialog
        //   .alert({
        //     title: '提示',
        //     message: '验证码不能为空！'
        //   })
        //   .then(() => {
        //     // on close
        //   })
      } else if (this.code != this.identifyCode) {
        // this.$message('验证码错误！');
        this.error = "验证码错误！";
        this.refreshCode();
      } else {
        this.$refs.nverify.startVerify()
      }
    },

    sendData: function (captchaVerifyParam) {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      const _this = this
      return new Promise((resolve, reject) => {
        this.$api.post(
        "user/card/recharge",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          code: this.cardNum,
          captchaVerifyParam
        },
        (res) => {
          this.error = res.data.message;
          if (res.data.code == "100") {
            //            this.$router.push({ path: '/pointsucceed' })
            this.step = 2;
            this.title = "充值成功";
            this.getnum = res.data.data;
            resolve(true)
            this.$api.get(
              "user/point/plist",
              {
                id_example: this.$store.state.id_example,
                token_user: this.$store.state.user_id,
                status: this.pointstatus,
                pageIndex: this.page,
              },
              (res) => {
                if (res.data.code == 100) {
                  this.point = res.data.data;
                  this.count = res.data.data.totalPage * 20;
                }
              }
            );
          } else if (
            res.data.code == "400"
          ) {
            _this.codeLoading = false;
            resolve(false)
          } else if (res.data.code == "800") {
            this.$toast("登录次数过多请稍后再试");
            _this.codeLoading = false;
            resolve(true)
          } else if (res.data.code == 0) {
            this.error = res.data.message;
            this.$toast(res.data.message);
            resolve(true)
          } else if (res.data.code == -101) {
            this.$toast(res.data.message);
            resolve(true)
          } else {
            resolve(true)
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？",
                })
                .then(() => {
                  this.$router.push({ name: "Login" });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
            
          }
        }
      );
      })
      
    },
    presented() {
      if (this.loginCode !== this.identifyCode) {
        this.$message({
          message: "验证码错误，请重新输入",
          duration: 1500,
          center: true,
        });
        return;
      }
      this.$confirm(
        "您将转赠" +
          this.integral +
          this.$store.state.name +
          "给用户:" +
          this.account +
          "",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$api.get(
            "user/point/transfer",
            {
              id_example: this.$store.state.id_example,
              token_user: this.$store.state.user_id,
              account: this.account,
              point: this.integral,
              pwd_user: this.password,
            },
            (res) => {
              if (res.data.code == -100) {
                this.$message({
                  message: res.data.message,
                  duration: 1500,
                  center: true,
                });
              } else {
                this.step = 3;
                this.resultAccount = res.data.data.account;
                this.resultPoint = res.data.data.point;
                this.resultTime = this.times(res.data.data.time);
                this.$store.commit("userInfo");
              }
            }
          );
        })
        .catch(() => {});
    },
    verifyMethods(captchaVerifyParam) {
      return new Promise(async(resolve, reject) => {
        const data = await this.sendData(captchaVerifyParam)
        resolve(data)
      })
    }
  },
  mounted() {
      console.log(this.$store.state.webInfo)
  console.log(typeof(this.$store.state.webInfo.card_status))
    if(this.$store.state.webInfo.card_status==0){
      this.$router.push({ name: 'Error'})
    }
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    var unit = localStorage.getItem("unit");
    var unitname = unit + "卡充值";
    this.title = unitname;
  },
};
</script>
<style lang="less" scoped>
.fadein-enter-active {
  transition: all 0.5s;
}
.fadein-leave-to {
  transition: all 0.5s;
}
// .fadein-transition {
//   transition: all .3s ease-in;
// 	height: 256px;
// 	opacity: 1;
// 	overflow: hidden;
// }
.fadein-enter {
  transform: translateX(-80%);
  opacity: 0;
  width: 0;
  height: 0;
  opacity: 0;
}
.fadein-leave-to {
  transform: translateX(110%);
  opacity: 0;
}
.buysuccess-text {
  p {
    color: rgb(122, 122, 122);
    font-size: 13px;
    text-align: center;
    line-height: 28px;
  }
}
#recharge {
  width: 975px;
  min-height: 605px;
  overflow: hidden;
  float: left;
  background: #fff;
  .inner {
    box-sizing: border-box;
    padding: 20px;
    .box-title {
      height: 40px;
      font-size: 24px;
      font-family: MicrosoftYaHei;
      color: #262626;
      line-height: 40px;
    }
    .box {
      display: flex;
      margin-top: 60px;

      .card {
        width: 385px;
        height: 214px;
        background-color: rgba(226, 49, 48, 1);
        border-radius: 9px;
        background-image: url(/static/img/cz_bg.png);
        background-size: cover;
        padding: 10px 30px 10px 17px;
        box-sizing: border-box;
        box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
        .ts1 {
          color: #fff;
          text-align: right;
        }
        .tbxq {
          color: #fff;
          padding-top: 40px;
          p {
            color: #fff;
            height: 19px;
            font-size: 13px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            line-height: 19px;
          }
          h1 {
            height: 41px;
            font-size: 29px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            line-height: 41px;
          }
        }
      }
      .box-form {
        padding-left: 90px;
        width: 315px;
        .tit {
          height: 17px;
          font-size: 13px;
          font-family: MicrosoftYaHei;
          color: #f36a60;
          line-height: 17px;
          padding-top: 10px;
          padding-left: 20px;
        }
        .inputbox {
          // margin: 40px;
          width: 100%;
          // height: 52px;
          // border: 1px solid rgba(230, 231, 231, 1);
          // padding: 0 15px;
          background: #fafafa;
          box-sizing: border-box;
          input {
            width: 100%;
            line-height: 52px;
            height: 52px;
            border: 1px solid rgba(230, 231, 231, 1);
            padding: 0 15px;
            background: #fafafa;
            box-sizing: border-box;
            &:hover {
              border: solid 1px #b8bfc9;
            }
            &:active,
            &:focus {
              border: solid 1px #e23130 !important;
            }
          }
        }
        .yzm-box {
          height: 52px;
          position: relative;
        }
        .yzm {
          width: 100px;
          height: 48px;
          float: left;
          margin-left: 10px;
          position: absolute;
          right: -8px;
        }
        button {
          width: 100%;
          height: 48px;
          background: #e23130;
          border-radius: 6px;
          border: 1px solid #e23130;
          text-align: center;
          font-size: 16px;
        }
      }
    }
    .box-tit {
      padding: 30px;
      background: #f5f5f5;
      margin-top: 50px;

      p {
        color: #98989898;
        font-size: 13px;
        font-family: MicrosoftYaHei;
        color: #989898;
        line-height: 24px;
      }
    }
  }
  .handleNav {
    height: 40px;
    background: #e3e3e3;
    border: 1px solid #ddd;
    margin-top: 55px;
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .name1 {
      width: 370px;
      margin-left: 20px;
      text-align: left;
    }
    .name2 {
      width: 240px;
    }
    .name3 {
      width: 270px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cont/recharge.vue